import { jsx as e, jsxs as d } from "react/jsx-runtime";
import * as p from "react";
import { cn as c } from "../../../lib/utils.js";
const t = p.forwardRef(({ className: r, variant: l = "default", width: n, height: a, animate: s = !0, style: i, ...o }, m) => e("div", { ref: m, className: c("bg-[hsl(30_15%_90%)] dark:bg-lpr-neutral/20", s && "animate-pulse", {
  default: "rounded-lg",
  text: "rounded h-4",
  circular: "rounded-full",
  rectangular: "rounded-none"
}[l], r), style: {
  width: typeof n == "number" ? `${n}px` : n,
  height: typeof a == "number" ? `${a}px` : a,
  ...i
}, ...o }));
t.displayName = "Skeleton";
const f = ({ lines: r = 3, className: l }) => e("div", { className: c("space-y-2", l), children: Array.from({ length: r }).map((n, a) => e(t, { variant: "text", width: a === r - 1 ? "60%" : "100%" }, a)) }), v = ({ className: r }) => d("div", { className: c("rounded-xl border border-border-color p-3 space-y-3", r), children: [d("div", { className: "flex items-center gap-4", children: [e(t, { variant: "circular", width: 48, height: 48 }), d("div", { className: "flex-1 space-y-2", children: [e(t, { variant: "text", width: "60%" }), e(t, { variant: "text", width: "40%" })] })] }), e(f, { lines: 3 })] }), y = ({ rows: r = 5, columns: l = 4, className: n }) => d("div", { className: c("space-y-6", n), children: [e("div", { className: "flex gap-4 mb-6", children: Array.from({ length: l }).map((a, s) => e(t, { variant: "text", className: "flex-1 h-5" }, s)) }), Array.from({ length: r }).map((a, s) => e("div", { className: "flex gap-4", children: Array.from({ length: l }).map((i, o) => e(t, { variant: "text", className: "flex-1 h-5" }, o)) }, s))] });
export {
  t as Skeleton,
  v as SkeletonCard,
  y as SkeletonTable,
  f as SkeletonText
};
//# sourceMappingURL=Skeleton.js.map
